import { httpClient } from '../http/httpClient'

export type GetCitiesResponse = string[]

export async function getCities(search?: string) {
  const { data } = await httpClient
    .get<GetCitiesResponse>('/crefaz/cities', {
      params: search ? { search } : undefined,
    })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
